export default "__VITE_ASSET__0a540d65__"